import styled from 'styled-components'

import Background from '../Background'
import BedroomList from './BedroomList'
import UnitList from './UnitList'
import Address from './Address'
import Price from './Price'
import ButtonGroup from './ButtonGroup'

import List from '../List'

const Body = styled(Background).attrs({
  type: 'white',
})`
  min-height: 250px;
  width: 100%;
  padding: ${props => (props.isGrid ? '14px 14px 12px 14px' : '14px 28px 14px 22px')};

  display: flex;
  flex-direction: column;

  ${BedroomList} {
    flex: 1;
  }

  ${Address}, ${Price}, ${ButtonGroup}, ${List} {
    transition: max-height 0.5s ease-in-out;
    max-height: ${props => (props.show ? 0 : '250px')};
    overflow: hidden;
  }

  ${UnitList} {
    transition: max-height 1s ease-in-out;
    max-height: ${props => (props.show ? '250px' : 0)};
    overflow: hidden;
  }
`

export default Body
